import { teacherProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import type { AxiosError } from 'axios';
import { useAtomValue } from 'jotai';
import { useQuery } from 'react-query';

import { QueryKeys } from '../interfaces/query-keys';
import type { WorkSchedule } from '../interfaces/work-schedule';
import { WorkScheduleService } from '../services/work-schedule.service';

const FIFTEEN_MINUTE_DELAY_MS = 60000 * 15;

export function useWorkSchedule() {
  const { environment } = useEnvironmentContext();
  const teacherProfile = useAtomValue(teacherProfileAtom);

  const {
    data: workSchedules,
    isLoading: isLoadingWorkSchedule,
    error: errorWorkSchedule,
  } = useQuery<WorkSchedule[] | null, AxiosError>(
    [QueryKeys.WorkSchedule, teacherProfile?.id],
    () => WorkScheduleService.getWorkSchedule(environment, teacherProfile?.id),
    {
      enabled: !!teacherProfile?.id,
      refetchInterval: FIFTEEN_MINUTE_DELAY_MS,
    }
  );

  const isScheduledToWorkAtTime = (time: Date) => {
    return workSchedules?.find((schedule: WorkSchedule) => {
      return time >= schedule.shiftStartTime && time <= schedule.shiftEndTime;
    });
  };

  const isScheduledToWorkNow = () => {
    return isScheduledToWorkAtTime(new Date());
  };

  return {
    workSchedules,
    isLoadingWorkSchedule,
    errorWorkSchedule,
    isScheduledToWorkNow,
    isScheduledToWorkAtTime,
  };
}
